import './App.css';
import {Grid} from "@mui/material";
import Pagina from "./Pagina/Pagina";
import '@fontsource/poppins/300.css';
import '@fontsource/poppins/400.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/600.css';
import '@fontsource/poppins/700.css';
import '@fontsource/poppins/800.css';
import '@fontsource/poppins/900.css';
import {useObtenerDataActualizada} from "./Modulo_Optimizacion_Data/Hooks/useObtenerDataActualizada";
import {obtenerFechaAct} from "./Servicios/BD/Actualizadores/obtenerFechaAct";
import {collection, query} from "firebase/firestore";
import {fire} from "./fire";
import {createContext, useEffect} from "react";


export const contexApp = createContext()


function App() {
    const {data: politicas, actualizarDataLocal: actPoliticas} = useObtenerDataActualizada({
        clave: 'politicas',
    })

    const valoresProvider = {
        politicas,
    }

    const {Provider} = contexApp;


    useEffect(() => {


        obtenerFechaAct('politicas').then((dox) => {
            let w = []
            let q = query(collection(fire, 'politicas'))
            actPoliticas({fecha: dox, wheres: w, query: q}).then()
        })


    }, []);
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Provider value={valoresProvider}>
                <Pagina/>
            </Provider>


        </Grid>
    );
}

export default App;
